import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'header-auction-detail',
  templateUrl:'header-auction-detail.component.html',
  styleUrls: ['./header-auction-detail.component.scss']
})
export class HeaderAuctionDetailComponent implements OnInit {

    constructor(public ref: DynamicDialogRef, public conf : DynamicDialogConfig) {}

    closeDialog() {
        this.ref.close();
    }

  ngOnInit() {
  }

}
